module.exports = __webpack_public_path__ + "img/Chevrolet.f4dea423.jpg";